// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__3_jps","input":"Form_input__2P-s9","btn":"Form_btn__2bcFn"};